// extracted by mini-css-extract-plugin
export default {"root":"styles_root__u2ORx","content":"styles_content__S0y3J","description":"styles_description__BG8mU","inputRow":"styles_inputRow__s7Gxb","form":"styles_form__V9xWa"};